import { FROM_PROMOTIONS_URL_FLAG, REGIONS_PAGE } from 'constant'
import getSearchByVehicleUrl from 'helpers/getSearchByVehicleUrl'
import qs from 'qs'
import { SESSION_STORAGE_LAST_CLICKED_PROMO } from './constants'

export const getEligibleTiresUrl = ({
  associatedPromotionsLink,
  promotionId,
  vehicle,
  hasActiveVehicle,
  associatedPromoId
}) => {
  const urlPrefix = `${hasActiveVehicle ? getSearchByVehicleUrl(vehicle) : ''}?promotionId=`
  const baseUrl = associatedPromoId ? `${urlPrefix}${associatedPromoId}&originalPromoId=${promotionId}` :
    ((associatedPromotionsLink && `${associatedPromotionsLink}&originalPromoId=${promotionId}`) || `${urlPrefix}${promotionId}`)

  return `${baseUrl}&${FROM_PROMOTIONS_URL_FLAG}`
}

export const getRegionNameLinkFromSearch = ({ search = '' }) => {
  const { regionName = '' } = qs.parse(search.slice(1)) || {}
  return regionName ? `${REGIONS_PAGE}${regionName.toLowerCase()}` : ''
}

export const getAssociatedPromoId = (associatedPromotionsLink = '') => associatedPromotionsLink.replace(/^(.*?)\?promotionId=/, '')

export const setPromoDataToSessionStorage = (promo) => {
  sessionStorage.setItem(SESSION_STORAGE_LAST_CLICKED_PROMO, JSON.stringify({ ...promo }))
}

export const getPromoDataFromSessionStorage = () => {
  const lastPromoClicked = sessionStorage.getItem(SESSION_STORAGE_LAST_CLICKED_PROMO)

  return lastPromoClicked && JSON.parse(lastPromoClicked)
}

export const clearPromoDataFromSessionStorage = () => {
  sessionStorage.removeItem(SESSION_STORAGE_LAST_CLICKED_PROMO)
}
